import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function Right(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 12 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M4.3 7.7a.49.49 0 01-.183-.033.508.508 0 01-.167-.117L.933 4.533a.499.499 0 01-.15-.366c0-.145.05-.267.15-.367a.48.48 0 01.7 0L4.3 6.467l6.05-6.05c.1-.1.22-.15.358-.15a.49.49 0 01.359.15c.1.1.15.219.15.358a.49.49 0 01-.15.358L4.65 7.55a.508.508 0 01-.167.117.49.49 0 01-.183.033z', fill: props.color ? props.color : '#fff' })));
}
export default Right;
